import { CommonProject, OrgWithChildren } from '../universal-nav/types';

export function setOrgsVisibility(
  rootOrg: OrgWithChildren,
  allAssignedProjects: CommonProject[]
) {
  const currentRootOrg = rootOrg;

  const checkVisibility = (childOrgs: OrgWithChildren[]): boolean => {
    let isVisible = false;

    childOrgs.forEach((org) => {
      const currentOrg = org;

      if (currentOrg.children?.length) {
        currentOrg.visible = checkVisibility(currentOrg.children);
      }

      if (currentOrg.visible) {
        isVisible = true;
        return;
      }

      const assignedProject = allAssignedProjects.find(
        (project) => project.project.accountId === currentOrg.id
      );

      if (assignedProject && assignedProject.availableProducts?.length) {
        currentOrg.visible = true;
        isVisible = true;
      }
    });

    return isVisible;
  };

  if (currentRootOrg.children?.length) {
    checkVisibility(rootOrg.children);
  }

  currentRootOrg.visible = true;
}
